<template>
  <v-container fill-height pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <span class="hidden-sm-and-up">Welcome, {{ username }}</span>
          <v-spacer></v-spacer>
          <span>{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <v-card flat color="merch" class="pa-2 ma-auto merchant-header">
          <div class="mt-0 pa-0 pr-2">
            <h3 class="font-weight-regular" v-text="merchant.name"></h3>
          </div>
        </v-card>
        <v-form>
          <v-card class="elevation-1 mb-1 pa-4 ma-auto">
            <v-layout column wrap>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs3 offset-xs3 pl-2>
                    <h2 class="font-weight-light">Existing Details</h2>
                  </v-flex>
                  <v-flex xs3 pl-2>
                    <h2 class="font-weight-light">Incoming Details</h2>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs3>
                    <label v-text="'Name'" class="pt-3"></label>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <v-text-field solo disabled :value="updatedMerchant.name"></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <v-text-field solo v-model="newMerchant.name"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs3>
                    <label v-text="'Phone'" class="pt-3"></label>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <v-text-field solo disabled :value="updatedMerchant.phone"></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <v-text-field solo v-model="newMerchant.phone"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs3>
                    <label v-text="'Category'" class="pt-3"></label>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <v-select
                      class="width70"
                      solo
                      disabled
                      v-model="updatedMerchant.business_type"
                      :items="businessTypes"
                      item-text="rep"
                      item-value="id"
                    ></v-select>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <v-autocomplete
                      class="width70"
                      solo
                      v-model="newMerchant.business_type"
                      :items="businessTypes"
                      item-text="rep"
                      item-value="id"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-flex class="justify mb-4">
                <v-btn class="text-xs-align" color="error" to="/cc" flat>CANCEL</v-btn>
                <v-btn class="text-xs-align" color="primary" @click="updateMerchant">UPDATE</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AppLayout from "../../layouts/app"
import { mapGetters, mapState } from "vuex"
import Vue from "vue"
import { UPDATE_MERCHANT } from "@/store/actions/merchant"

export default {
  name: "CCUpdateMerchant",
  data() {
    return {
      getDate: new Date(),
      valid: false,
      newMerchant: {},
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ]
    }
  },
  computed: {
    ...mapGetters({
      getMerchantById: "getMerchantById"
    }),

    ...mapState({
      businessTypes: state => state.common.businessTypes
    }),
    username() {
      return this.$store.getters.getProfile.first_name
    },
    merchant: function() {
      return this.getMerchantById(this.$route.params.merchant_id)
    },
    updatedMerchant: function() {
      return JSON.parse(this.merchant.current_ok_state)
    },
  },
  methods: {
    accept(title) {
      title = true
    },
    reject(title) {
      title = false
    },
    updateMerchant() {
      this.$store
        .dispatch(UPDATE_MERCHANT, this.newMerchant)
        .then(() => {
          this.$router.push("/cc")
      })
    }
  },
  created() {
    this.$emit("update:layout", AppLayout)
    this.newMerchant = {...this.merchant}
  }
}
</script>

<style scoped>
.merchant-header {
  background: rgba(0, 0, 0, 0.1)
}
hr {
  width: 95%;
  border-color: rgba(0, 0, 0, 0.1);
  margin: auto
}
</style>
